import { z } from "zod";
import { locales } from "../../../locales";

export const postUserLanguageSchema = z.object({
	language: z.enum(locales),
});

export type PostUserLanguageSchema = z.infer<typeof postUserLanguageSchema>;
